import * as types from '../mutations'
export default {
	namespaced: true,

	state: {
		activeCourseId: null,
		selfCourses: [],
	},

	actions: {
		fetchActive({ rootState, state, commit }) {			
			return (
				(state.selfCourses.length ? state.selfCourses.length : null) ||
				window.axios.get(
					`center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/getStudentActiveCourse`
				).then((res) => {
					commit(types.SELF_COURSES, res.data);
					return res.data;
				})
			);
		},

		clear({ commit }) {
			commit('CLEAR');
		},
	},

	mutations: {
		[types.SELF_COURSES](state, data) {
			state.selfCourses = data;
		},

		CLEAR(state) {
			state.activeCourseId = null;
			state.selfCourses = [];
		}
	},

	getters: {
		getCourseById: state => id => state.selfCourses.find(course => course.Id === id)
	}
}